import {
    booleanAttribute,
    Directive,
    ElementRef,
    HostBinding,
    HostListener,
    inject,
    input,
} from '@angular/core';

const controls = 'a, button, input, label, select, textarea, app-tooltip';

const forwardedClicks = new WeakSet<Event>();

@Directive({
    selector: '[appCheckboxArea]',
    standalone: true,
})
export class CheckboxAreaDirective {
    readonly disabled = input(false, {
        alias: 'appCheckboxAreaDisabled',
        transform: booleanAttribute,
    });

    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    @HostBinding('style.cursor')
    protected get cursor(): string | null {
        return this.disabled() ? null : 'pointer';
    }

    @HostListener('click', ['$event'])
    protected forwardToCheckbox(event: MouseEvent): void {
        const host = this.host.nativeElement;
        if (
            forwardedClicks.has(event) ||
            landsOnAControl(event.target) ||
            selectsTextInside(host)
        ) {
            return;
        }
        forwardedClicks.add(event);
        if (this.disabled()) {
            return;
        }
        host.querySelector<HTMLInputElement>('input[type="checkbox"]')?.click();
    }
}

function landsOnAControl(target: EventTarget | null): boolean {
    return target instanceof Element && target.closest(controls) !== null;
}

function selectsTextInside(host: HTMLElement): boolean {
    const selection = window.getSelection();
    if (selection === null || selection.isCollapsed) {
        return false;
    }
    return Array.from({length: selection.rangeCount}, (_, index) =>
        selection.getRangeAt(index),
    ).some(range => range.intersectsNode(host));
}
